import {
  IconCommand,
  IconCommon,
  IconCompass,
  IconDashboard,
  IconList,
  IconLoop,
  IconRobot,
  IconSettings,
  IconThunderbolt,
  IconUser,
} from '@arco-design/web-react/icon';
import React, { useMemo } from 'react';
import { type Route, routes } from './route';
import { useAuth } from '@/providers/AuthProvider';

export const enum NavMenuKeys {
  Dashboard = 'dashboard',
  Permission = 'permission',
  Fund = 'fund',
  Settings = 'settings',
  Project = 'project',
  Operation = 'operation',
  Finance = 'finance',
  Stock = 'stock',
  Allowance = 'allowance',
  Trade = 'trade',
  Game = 'game',
  Shop = 'shop',
  Task = 'task',
  Logs = 'logs',
  Yuebao = 'yuebao',
  Member = 'member',
  Activity = 'activity',
  TeamReport = 'teamReport',
}

const iconStyle = {
  fontSize: '18px',
  verticalAlign: 'text-bottom',
};

export const useMenus = (): Route[] => {
  const { user } = useAuth();
  const menus = user?.menus ?? [];
  const existsMenus = menus.map((v) => v.name);
  return useMemo(() => {
    const navMenus: Record<string, Route> = {
      [NavMenuKeys.Dashboard]: {
        path: NavMenuKeys.Dashboard,
        name: 'Dashboard',
        icon: <IconDashboard style={iconStyle} />,
        children: [],
        enable: true,
        order: 1,
      },
      [NavMenuKeys.Operation]: {
        path: NavMenuKeys.Operation,
        name: '运营管理',
        icon: <IconUser style={iconStyle} />,
        children: [],
        enable: false,
      },
      [NavMenuKeys.Finance]: {
        path: NavMenuKeys.Finance,
        name: '财务管理',
        icon: <IconCommon style={iconStyle} />,
        children: [],
        enable: true,
        order: 3,
      },
      [NavMenuKeys.Stock]: {
        path: NavMenuKeys.Stock,
        name: '股票管理',
        icon: <IconThunderbolt style={iconStyle} />,
        children: [],
        enable: false,
      },
      [NavMenuKeys.Trade]: {
        path: NavMenuKeys.Trade,
        name: '交易管理',
        icon: <IconLoop style={iconStyle} />,
        children: [],
        enable: false,
      },
      [NavMenuKeys.Game]: {
        path: NavMenuKeys.Game,
        name: '行情游戏',
        icon: <IconRobot style={iconStyle} />,
        children: [],
        enable: false,
      },
      [NavMenuKeys.Activity]: {
        path: NavMenuKeys.Activity,
        name: '活动管理',
        icon: <IconRobot style={iconStyle} />,
        children: [],
        enable: true,
        order: 5,
      },
      [NavMenuKeys.Task]: {
        path: NavMenuKeys.Task,
        name: '兑换商品管理',
        icon: <IconRobot style={iconStyle} />,
        children: [],
        enable: true,
        order: 4,
      },
      [NavMenuKeys.Allowance]: {
        path: NavMenuKeys.Allowance,
        name: '津贴管理',
        icon: <IconRobot style={iconStyle} />,
        children: [],
        enable: false,
      },
      [NavMenuKeys.Logs]: {
        path: NavMenuKeys.Logs,
        name: '日志管理',
        icon: <IconList style={iconStyle} />,
        children: [],
        enable: true,
        order: 6,
      },
      [NavMenuKeys.Settings]: {
        path: NavMenuKeys.Settings,
        name: '系统设定',
        icon: <IconSettings style={iconStyle} />,
        children: [],
        enable: true,
        order: 8,
      },
      [NavMenuKeys.Fund]: {
        path: NavMenuKeys.Fund,
        name: '基金管理',
        icon: <IconCompass style={iconStyle} />,
        children: [],
        enable: false,
      },
      [NavMenuKeys.TeamReport]: {
        path: NavMenuKeys.TeamReport,
        name: '团队报表',
        icon: <IconCompass style={iconStyle} />,
        children: [],
        enable: true,
        order: 10,
      },
      [NavMenuKeys.Shop]: {
        path: NavMenuKeys.Shop,
        name: '商品管理',
        icon: <IconCompass style={iconStyle} />,
        children: [],
        enable: false,
      },
      [NavMenuKeys.Yuebao]: {
        path: NavMenuKeys.Yuebao,
        name: '余额宝',
        icon: <IconCommand style={iconStyle} />,
        children: [],
        enable: true,
        order: 8,
      },
      [NavMenuKeys.Project]: {
        path: NavMenuKeys.Project,
        name: '项目管理',
        icon: <IconCompass style={iconStyle} />,
        children: [],
        enable: true,
        order: 7,
      },
      [NavMenuKeys.Permission]: {
        path: NavMenuKeys.Permission,
        name: '权限管理',
        icon: <IconCompass style={iconStyle} />,
        children: [],
        enable: true,
        order: 7,
      },
      [NavMenuKeys.Member]: {
        path: NavMenuKeys.Member,
        name: '会员管理',
        icon: <IconCompass style={iconStyle} />,
        children: [],
        enable: true,
        order: 2,
      },
    };
    routes
      .filter((v) => v.enable)
      // .filter((v) => existsMenus.includes(v.path ?? '404'))
      .forEach((v) => {
        if (v.module) {
          navMenus[v.module].children?.push(v);
        }
      });
    const menus = Object.values(navMenus);
    menus.sort((a, b) => {
      const aOrder = a.order || 0;
      const bOrder = b.order || 0;
      return aOrder - bOrder;
    });
    return menus.filter((v) => v.enable);
  }, []);
};
